import React, { useState } from "react";
import styles from "./item.module.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import TextWrap from "../../../custom/TextWrap";
import { FaRegStar, FaStar } from "react-icons/fa";
import { IoReloadSharp } from "react-icons/io5";
import { formattedAmount } from "../../../utils/helpers/Functions.helper";

const ProductsCard = ({
  allProduct,
  handleAllProductClicked,
  handleLoadMore,
  hasMore,
}) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [, setCursorPosition] = useState({ x: 0, y: 0 });
  const [showMagnifier] = useState(false);

  const handleMouseHover = (e) => {
    const { left, top, width, height } =
      e.currentTarget.getBoundingClientRect();

    const x = ((e.pageX - left - window.scrollX) / width) * 100;
    const y = ((e.pageY - top - window.scrollY) / height) * 100;
    setPosition({ x, y });

    setCursorPosition({
      x: e.pageX - left - window.scrollX,
      y: e.pageY - top - window.scrollY,
    });
  };
 
  
  return (
    <>
      <div className={styles.item__container}>
        {allProduct && allProduct.length > 0 ? (
          allProduct?.map((item) => (
            <main
              className="relative group text-center rounded-xl overflow-hidden shadow-md n-card hover:shadow-lg transition-shadow duration-300"
              key={item._id}
              onClick={() => handleAllProductClicked(item)}
            >
              <div
                // onClick={handleNavigateProductDetailPage}
                className="h-60 overflow-hidden rounded-t-lg object-center"
              >
                <LazyLoadImage
                  loading="lazy"
                  src={item?.primary_image}
                  alt="Product Image"
                  className="w-full h-full object-contain transform transition-transform duration-300 cursor-pointer"
                />
                {showMagnifier && (
                  <div
                    className="absolute bottom-0 border border-gray-400 pointer-events-none "
                    style={{
                      width: "100%",
                      height: "200px",
                      backgroundImage: `url(${item?.primary_image})`,
                      backgroundSize: "250%",
                      backgroundPosition: `${position.x}%  ${position.y}%`,
                      backgroundColor: "white",
                    }}
                  ></div>
                )}
                {!item?.in_stock && (
                  <div className="absolute inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-9">
                    <p className="text-white font-bold text-lg">Out of Stock</p>
                  </div>
                )}
              </div>

              <button
                className={
                  "absolute w-fit top-[14rem] left-1/2 transform -translate-x-1/2 px-2 py-1 rounded-md text-white bg-[#e34e4e] z-0 shadow-md transition-all duration-200"
                }
              >
                {item?.user?.first_name}
              </button>

              <div className="p-3">
                <p className="text-sm text-gray-500 mt-2">
                  {item?.subCategory?.name || "N/A"}
                </p>
                
                <div className="flex justify-center items-center mt-1">
                  {[...Array(5)].map((_, index) =>
                    index < item?.average_rating ? (
                      <FaStar key={index} className="text-orange-500 text-xs" />
                    ) : (
                      <FaRegStar
                        key={index}
                        className="text-orange-500 text-xs"
                      />
                    )
                  )}
                  <span className="text-sm text-gray-500 ml-2">
                    ({item?.average_rating?.toFixed(1) || "0.0"})
                  </span>
                </div>

                <p className="font-bold text-black text-base mt-1 line-clamp-1">
                  {TextWrap(item?.name || "No Name Available")}
                </p>
                <p className="text-gray-500 text-sm mt-1 line-clamp-2">
                  {item?.description?.replace(/<[^>]+>/g, "") ||
                    "No description available"}
                </p>

                <div className="flex justify-center items-center mt-2 mb-3">
                  <p className="text-[#e34e4e] font-bold text-lg mr-2">
                    {/* {formattedAmount(item.product_details[0].sales_price.$numberDecimal) || "0.00"} */}
                    {formattedAmount(item.product_details?.[0]?.taxData?.grandTotal?.$numberDecimal ) || "0.00"}
                  </p>
                  <p className="text-gray-400 line-through text-base">
                    
                  {formattedAmount(item.product_details?.[0].mrp_price.$numberDecimal) || "0.00"}
                  </p>
                </div>
              </div>
            </main>
          ))
        ) : (
          <img src="/no-product-found.png" alt="No product found" />
        )}
        {hasMore > allProduct?.length && (
          <>
            {/* <button onClick={handleLoadMore} className={styles.loadMoreButton}>
              Load More
            </button> */}
            <div className={styles.loadMoreBox}>
              <div
                className={styles.LoadMoreButtonContainer}
                onClick={handleLoadMore}
              >
                <button className={styles.loadMoreButton}>Load More</button>
                <IoReloadSharp className={styles.loadMoreCategoryIcon} />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ProductsCard;
